







































import Vue, { PropType } from 'vue';

import { PeerGroupMember } from '@/models/orgStructure';
import { BasePeerGroup, MemberRole } from '@/models';
import { groupRoleName } from '@/groupRole';

import LazyRenderingList from '@/components/LazyRenderingList.vue';
import OrganizationUserCard from '@/components/OrganizationUserCard.vue';
import PeerGroupMemberActionsMenu from '@/components/PeerGroupMemberActionsMenu.vue';

export default Vue.extend({
  components: {
    LazyRenderingList,
    OrganizationUserCard,
    PeerGroupMemberActionsMenu
  },

  props: {
    members: {
      type: Array as PropType<PeerGroupMember[]>,
      required: true
    },

    peerGroup: {
      type: Object as PropType<BasePeerGroup>,
      required: true
    },

    canDuplicate: Boolean
  },

  data() {
    return {
      rawFilter: '',
      inputFocused: false,
      multiRole: MemberRole.STUDENT
    };
  },

  computed: {
    withFriendlyRoles(): [PeerGroupMember, string][] {
      return this.members.map(m => [
        m,
        groupRoleName(m.role, this.peerGroup).toUpperCase()
      ]);
    }
  },

  methods: {
    userClick(userId: number) {
      const orgId = this.$route.params['organizationId'] as string;
      this.$router.push({
        name: 'OrganizationUser',
        params: { organizationId: orgId, userId: `${userId}` }
      });
    }
  }
});
